import React, { useEffect, useState } from "react";
import { Col, Row, Container } from "react-bootstrap";
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { CircularProgress } from '@mui/material';
import { SESSION_STORAGE_ACCOUNT_KEY, getSessionStorageItem, SESSION_STORAGE_ESIGN_AUTH_KEY } from '../../../../sessionStorage'

export default function DocuSign(props) {

    const { path } = useParams();
    const [iframeUrl, setIframeUrl] = useState("");

    const covrServicesUrl = window.__ENV__.REACT_APP_COVR_SERVICES_URL;
    let passcode = props.formState.steps.paymentInfo.socialSecurityNumber.replace(/-/g, '').substring(5);
    let birthdate = props.formState.steps.basicInfo.birthdate;
    let applicationID = props.formState.appIdentifier;

    useEffect(() => {

        // TODO when coming back from esign but formState still points to sign instead of status - routing can be improved
        if (path && path === 'status') {
            return;
        }

        const esignAuth = sessionStorage.getItem(SESSION_STORAGE_ESIGN_AUTH_KEY) && JSON.parse(sessionStorage.getItem(SESSION_STORAGE_ESIGN_AUTH_KEY));
        if (esignAuth) {
            passcode = esignAuth.passcode;
            birthdate = esignAuth.birthdate;
            applicationID = esignAuth.applicationID;
        }

        fetch(`${covrServicesUrl}/api/ESign/GetEsignIframeUrl?passcode=${passcode}&birthdate=${birthdate}&applicationID=${applicationID}&esignReturnPath=/quote/aflac/hospital-confinement/EsignReturn`,
            {
                method: 'GET',
                headers: {
                    'SessionId': getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY).sessionId
                }
            })
            .then(res => res.json())
            .then(json => {
                setIframeUrl(json);
            })
    }, []);

    return (
        <Container fluid className=" container-fluid mt-4 pt-4 border-class" >
            <Row>
                <Col>
                    {iframeUrl &&
                        <iframe src={iframeUrl} height="1000px" width="100%" scrolling="auto" frameBorder="0" title="Sign your application with Docusign" name='aflac-docusign' id='aflac-docusign'/>
                    }

                    {!iframeUrl &&
                        <div className='d-flex justify-content-center'><CircularProgress /></div>
                    }
                </Col>
            </Row>
        </Container >
    )
}

DocuSign.propTypes = {
    formState: PropTypes.object.isRequired,
}
